import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import "@/styles/buy-illustration.css";

const IMAGE = "/assets/artwork/buy/element-site-anime";

export const BuyAnimatedIllustration = () => {
  const ref = useRef(null);
  const imageRef = useRef(null);
  const inView = useInView(ref, { amount: 0.08 });
  const [loaded, setLoaded] = useState(false);
  const [revealed, setRevealed] = useState(false);
  const [fallback, setFallback] = useState(false);
  const [visible, setVisible] = useState(() => !document.hidden);
  const [reduced, setReduced] = useState(() => window.matchMedia("(prefers-reduced-motion: reduce)").matches);

  useEffect(() => {
    const media = window.matchMedia("(prefers-reduced-motion: reduce)");
    const onMotion = () => setReduced(media.matches);
    const onVisibility = () => setVisible(!document.hidden);
    media.addEventListener("change", onMotion);
    document.addEventListener("visibilitychange", onVisibility);
    if (imageRef.current?.complete && imageRef.current.naturalWidth) setLoaded(true);
    return () => {
      media.removeEventListener("change", onMotion);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, []);

  useEffect(() => {
    if (loaded && (inView || reduced)) setRevealed(true);
  }, [loaded, inView, reduced]);

  return (
    <figure ref={ref} className="buy-illustration" aria-hidden="true" data-testid="buy-animated-illustration"
      data-revealed={revealed} data-reduced={reduced} data-loaded={loaded}
      data-running={inView && visible && !reduced && loaded}>
      <div className="buy-illustration__reveal" data-testid="buy-illustration-reveal">
        <div className="buy-illustration__float" data-testid="buy-illustration-float">
          <span className="buy-illustration__glow" data-testid="buy-illustration-glow"
            style={{ "--buy-illustration-mask": `url(${IMAGE}.${fallback ? "png" : "webp"})` }} />
          <picture>
            {!fallback && <source srcSet={`${IMAGE}.webp`} type="image/webp" />}
            <img ref={imageRef} src={`${IMAGE}.png`} width="1672" height="941" alt="" draggable="false"
              loading="lazy" decoding="async" fetchPriority="low" data-testid="buy-illustration-image"
              onLoad={() => setLoaded(true)} onError={() => { if (!fallback) setFallback(true); }} />
          </picture>
        </div>
      </div>
    </figure>
  );
};